import * as angular from 'angular';

export function setTranslations(translations: any, locale: string) {
  try {
    angular.module('wixShoutoutTranslations');
  } catch (e) {
    angular.module('wixShoutoutTranslations', ['pascalprecht.translate']);
  }

  angular.module('wixShoutoutTranslations').config([
    '$translateProvider',
    function ($translateProvider: any) {
      $translateProvider.translations(locale, translations);
      if ($translateProvider.preferredLanguage) {
        $translateProvider.preferredLanguage(locale);
      }
    },
  ]);
}
